import * as React from 'react';
import { getNativeVersion } from '@shopee-user/spx-customization-logic';
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';
import { Feature } from '@shopee-user/feature-toggle';

import cx from 'classnames';
import styles from './style.scss';

export default function VersionNumber({ className }: { className?: string }) {
  const nativeVersion = getNativeVersion();
  const version = nativeVersion ? `v.${nativeVersion}` : '';

  const { layout } = useResponsiveLayout();
  const isSpxOrangeBackgroundUiEnabled =
    isFeatureEnabled(Feature.SPXOrangeBackgroundUI, false) &&
    layout === Layout.Mobile;

  return (
    <div className={className}>
      <div
        className={cx(styles.versionNumber, {
          [styles.whiteFont]: isSpxOrangeBackgroundUiEnabled,
        })}
      >
        {version}
      </div>
    </div>
  );
}
